import { __decorate, __metadata } from "tslib";
import { Serialize, Type } from '@ftr/serialization';
import { LocalTime, ZoneId } from '@js-joda/core';
import { IsBoolean, IsEmail, IsEnum, IsNotEmpty, IsOptional, IsUUID, IsUrl, MaxLength, Validate, ValidateNested, } from 'class-validator';
import { IS_EMAIL_DEFAULT_OPTIONS, SupportedCountry, SupportedState, SupportedTimezone } from '../../shared/validator';
import { ServiceFeeConfiguration } from '../../type/core';
import { Currency } from '../../type/order';
import { LanguageModelDialect, STTProvider } from '../../type/recording';
import { UUID_VERSION } from '../../type/shared';
import { MFARequirementsConfiguration } from '../court-system';
export const CUSTOMER_REFERENCE_MAX_LENGTH = 200;
/**
 * FTRX-5000 New Pattern Notice
 * For additional context, please see: https://www.notion.so/ftrlabs/Beast-CRUD-Pattern-bbe75d6565104bdf9a417fd6def859a3
 */
export class UpdateConfigurationBody {
}
__decorate([
    IsOptional(),
    IsUUID(UUID_VERSION),
    __metadata("design:type", String)
], UpdateConfigurationBody.prototype, "courtSystemId", void 0);
__decorate([
    IsOptional(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdateConfigurationBody.prototype, "stripePublicApiKey", void 0);
__decorate([
    IsOptional(),
    IsEmail(IS_EMAIL_DEFAULT_OPTIONS),
    __metadata("design:type", String)
], UpdateConfigurationBody.prototype, "ordersHelpEmail", void 0);
__decorate([
    IsOptional(),
    IsEnum(Currency),
    __metadata("design:type", String)
], UpdateConfigurationBody.prototype, "defaultCurrency", void 0);
__decorate([
    IsOptional(),
    Serialize(),
    Validate(SupportedTimezone),
    Type(() => ZoneId),
    __metadata("design:type", ZoneId
    /**
     * The time of day at which the court system opens
     */
    )
], UpdateConfigurationBody.prototype, "timeZoneId", void 0);
__decorate([
    IsOptional(),
    Serialize(),
    Type(() => LocalTime),
    __metadata("design:type", LocalTime
    /**
     * The time of day at which the court system closes
     */
    )
], UpdateConfigurationBody.prototype, "startOfDay", void 0);
__decorate([
    IsOptional(),
    Serialize(),
    Type(() => LocalTime),
    __metadata("design:type", LocalTime
    /**
     * The speech to text provider used to generate transcripts from court recordings
     */
    )
], UpdateConfigurationBody.prototype, "endOfDay", void 0);
__decorate([
    IsOptional(),
    IsEnum(STTProvider),
    __metadata("design:type", String)
], UpdateConfigurationBody.prototype, "sttProvider", void 0);
__decorate([
    IsOptional(),
    IsEnum(LanguageModelDialect),
    __metadata("design:type", String)
], UpdateConfigurationBody.prototype, "dialect", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", String)
], UpdateConfigurationBody.prototype, "contactDetails", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateConfigurationBody.prototype, "isDepartmentsEnabled", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateConfigurationBody.prototype, "restrictedByLocation", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateConfigurationBody.prototype, "restrictedByDepartment", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => ServiceFeeConfiguration),
    __metadata("design:type", ServiceFeeConfiguration
    /**
     * The optional country code assigned to this court system. Undefined if not set.
     */
    )
], UpdateConfigurationBody.prototype, "serviceFee", void 0);
__decorate([
    IsOptional(),
    Validate(SupportedCountry),
    __metadata("design:type", String)
], UpdateConfigurationBody.prototype, "countryCode", void 0);
__decorate([
    IsOptional(),
    Validate(SupportedState),
    __metadata("design:type", Object)
], UpdateConfigurationBody.prototype, "stateCode", void 0);
__decorate([
    IsOptional(),
    IsUrl(),
    __metadata("design:type", Object)
], UpdateConfigurationBody.prototype, "logoUrl", void 0);
__decorate([
    IsOptional(),
    IsUrl(),
    __metadata("design:type", Object)
], UpdateConfigurationBody.prototype, "externalTranscriptOrderLink", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateConfigurationBody.prototype, "hasRestApiKeyAccess", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => MFARequirementsConfiguration),
    __metadata("design:type", MFARequirementsConfiguration
    /**
     * Customer reference used for marketing purposes
     */
    )
], UpdateConfigurationBody.prototype, "mfaRequirements", void 0);
__decorate([
    IsOptional(),
    MaxLength(CUSTOMER_REFERENCE_MAX_LENGTH),
    __metadata("design:type", Object)
], UpdateConfigurationBody.prototype, "customerReference", void 0);
